import classNames from "classnames"

const TileTitle = (props) => {

    const { classes, onClick, titleComponent } = props
    const className = classNames(classes, "tile-title", {
        "p-0": props.disableTitlePadding
    })

    const TitleComponent = titleComponent || "h4"

    return (
        <TitleComponent
            className={className}
            onClick={onClick}
        >
            {props.children}
        </TitleComponent>
    )
}

export default TileTitle